



























































































import Vue from "vue";
import { callApi } from "@/lib/api";
import InputText from "@/components/atoms/InputText.vue";

export default Vue.extend({
  components: { InputText },
  props: {
    novelId: String, //小説ID
    items: Array as object, //登場人物フォルダ
    charactersCount: Number, //フォルダに含まれる登場人物の数
    isInsert: Boolean, //状態管理用。登場人物にフォルダを設定する状態かどうかを管理
    selectedCharacter: Object, //フォルダを設定しようとしている登場人物
    selectedFolderId: String, //現在表示しているフォルダID
  },
  data() {
    return {
      folders: this.items || [],
      wholeCharacterCount: null,
      isEditMode: false,
      pickedDestinationInsertFolder: null,
      toastNoName: null,
      deletedFolderIds: null,
    };
  },
  watch: {
    items() {
      this.folders = this.items;
    },
    charactersCount() {
      this.wholeCharacterCount = this.charactersCount;
    },
  },
  async created() {
    this.wholeCharacterCount = this.charactersCount;
  },
  methods: {
    selectFolder(characterFolderId) {
      this.$emit("selectedFolder", characterFolderId);
    },
    async completeSetFolder() {
      const currentCharacterFolderId = this.selectedFolderId;

      //移動前のフォルダから登場人物を抜いて、移動先に登場人物を追加する
      this.folders.forEach((el) => {
        if (el.characterFolderId === currentCharacterFolderId) {
          el.characterKeys.splice(el.characterKeys.indexOf(this.selectedCharacter.characterId), 1);
        }
        if (el.characterFolderId === this.pickedDestinationInsertFolder) {
          el.characterKeys.push(this.selectedCharacter.characterId);
        }
      });

      await this.updateCharacterFolder(this.folders);
      this.$emit("clickCompleteSetFolder");
    },
    clickCancelInsertFolder() {
      this.$emit("clickCancelInsertFolder");
    },
    async createCharacterFolder() {
      const { novelId } = this;
      const query = `
      mutation CreateCharacterFolder ($input: CreateCharacterFolderInput!){
        createCharacterFolder (input: $input) {
          characterFolderId
          name
        }
      }
      `;
      const { createCharacterFolder } = await callApi(query, {
        input: {
          novelId,
          name: "新しいフォルダ",
        },
      });
      const folder = {
        characterFolderId: createCharacterFolder.characterFolderId,
        name: createCharacterFolder.name,
        characterKeys: [],
      };
      this.folders.push(folder);
    },
    deleteCharacterFolder(key) {
      if (!this.deletedFolderIds) {
        this.deletedFolderIds = [];
      }
      const result = this.folders.filter((folder) => {
        return folder.characterFolderId !== key;
      });
      this.folders = result;
      this.deletedFolderIds.push(key);
    },
    moveCharacterFolder(key, direction) {
      let sourceIndex = this.folders.findIndex((folder) => {
        return folder.characterFolderId === key;
      });
      const targetIndex = direction === "up" ? sourceIndex - 1 : sourceIndex + 1;
      if (targetIndex >= 0 || this.folders.length > targetIndex) {
        let temp = this.folders[sourceIndex];
        Vue.set(this.folders, sourceIndex, this.folders[targetIndex]);
        Vue.set(this.folders, targetIndex, temp);
      }
    },
    async switchEditMode() {
      //編集終了を押した場合、かつ変更していた場合
      if (this.isEditMode) {
        //フォルダ名が空欄があったら更新しないでエラー出す
        let isExistNoNameFolder = false;
        this.folders.forEach((element) => {
          if (!element.name) {
            isExistNoNameFolder = true;
          }
        });
        if (isExistNoNameFolder) {
          this.toastNoName = true;
          setTimeout(() => (this.toastNoName = null), 2000);
          return;
        }
        await this.updateCharacterFolder(this.folders);
      }
      this.deletedFolderIds = null;
      this.isEditMode = !this.isEditMode;
    },
    async updateCharacterFolder(folders) {
      const { novelId } = this;
      const query = `
          mutation UpdateCharacterFolders ($input: UpdateCharacterFolderInput!){
            updateCharacterFolder (input: $input) {
              novelId
              items {
                characterFolderId
                name
                characterKeys
              }
            }
          }
        `;
      //変なデータが有ったらこっそり修正する
      folders.forEach((element) => {
        element.characterKeys = element.characterKeys
          .filter((key) => key != null)
          .filter((el, index, selfArray) => {
            //重複Keyは排除
            return selfArray.indexOf(el) === index;
          });
      });
      const result = await callApi(query, {
        input: {
          novelId,
          items: folders,
        },
      });
      return result;
    },
  },
});
